import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {NavLink,useHistory} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';

//Css start for this components
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),  
       width:'98%', 
    },
  },  
  rootBox: {
    flexGrow: 1,
},
paper: {  
  width: '100%',
  boxShadow:'none',
},
  signMain:{
    position: 'fixed',
    width: '100%',
    background: 'rgba(0,0,0,.5)', 
    height:'100vh', 
    top:'0',
    zIndex:'1'
  },
  signInBtn:{
    border: '1px solid rgba(36, 97, 142, 1)',
    color: '#fff',
    background:'rgba(36, 97, 142, 1)!important',
    fontSize: '12px',
    width: '160px',   
  },
  formLogo:{
    textAlign: 'center',
    width: '100%',
    paddingTop: '15px',
    '& p':{
        textAlign: 'right',
        margin: '0px 0 -20px',
        paddingRight: '15px',
        fontSize: '25px',
        },
        '& a':{
            color:'#24618E',
       }
  },
  rootForm:{      
      margin:'10px auto 20px',
      border: '1px solid rgba(0, 167, 93, 1)',
      padding: '10px',   
      borderRadius:'5px',
      boxShadow: '1px 4px 5px 1px #ccc',
      '@media only screen and (max-width: 3500px)': {
        width: '80%',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '85%',
      },
      '& input#email':{
          padding:'10px',
      },
      '& input#password':{
        padding:'10px',
       },  
       '& h3':{
        color: '#24618E',        
        marginTop: '0px',
        marginBottom: '0',
        '@media only screen and (max-width: 3500px)': {
          fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
          fontSize: '26pt',
        },
       }    
  },
  formInput:{
      width:'100%',     
  },
  OtherLink:{
    width: '80%',
    margin: '0 auto',
    '& a':{
        color:'#24618E',
      }
  },
  closePassWin:{
    background: '#24618E',
    padding: '10px 50px',
    color: '#fff',    
    border: '1px solid #24618E',
    borderRadius: '5px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',     
    },
  }, 
    errMsgUpdated : {
      '& span' : {
        fontSize:'11pt !important'
    }
},
userFormContainer: {
  '@media only screen and (max-width: 3500px)': {
    width: '500px',
    paddingTop: '90px',
  },
  '@media only screen and (min-width: 3501px)': {
    width: '650px',
    maxWidth: '650px',
    paddingTop: '250px',
    '& input': {
      fontSize: '22pt',
    }
  },
},
closeIcon: {
  '&:hover': {
    color: '#CC0000',
  }
},
formIcon:{
  '@media only screen and (max-width: 3500px)': {
    width: '215px', 
    height:'50px'
  },
  '@media only screen and (min-width: 3501px)': {
    width: '300px', 
    height:'70px'
  },
}
}));
//Css end ...

//Start PasswordUpdated component code ...
export default function PasswordUpdated() {
    const [spacing, setSpacing] = React.useState(2);
    const [errPopUp, setErrPopUp] = React.useState(false);
    const classes = useStyles();
    let history = useHistory();
    const handleChange = (event) => {
      setSpacing(Number(event.target.value));
    };
    const validateForm = async e => {
      e.preventDefault();      
      history.push("/reset_password");      
    }  
    const ShowErrPopUP = () => {
        setErrPopUp(false);
    };
  return (
    <React.Fragment>
      <Header/>
    <CssBaseline />
    <div className={classes.signMain}>
    <Container maxWidth="sm" className={classes.userFormContainer}>
      <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px',paddingBottom: '10px',position: 'relative',border:'1px solid #24618E',borderRadius:'5px', }}>
      <div className={classes.formLogo}>
      <p><NavLink className={classes.closeIcon}  to="/" title='close'><FontAwesomeIcon icon={faTimes} title='close'/></NavLink></p>
      <img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.formIcon}></img>
      </div>
      <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)}>  
      <h3>Password Updated</h3>
      <img src={require('../../assets/images/hrimg.svg')} style={{marginBottom: '10px',width:'100%',height:'1px'}}/>
      <Grid container className={classes.rootBox} spacing={12}>
      <Grid item xs={12}>
        <Grid container justify="center" spacing={spacing}> 
        <Grid xs={12} item>
              <Paper className={classes.paper} >
              <div className={classes.errMsgUpdated}> <ErrorMessage message={'Your password has been updated and you\'re back in business'} visible={ShowErrPopUP} show={true} msgType={'success'} /> </div>
              </Paper>
        </Grid>
        <Grid xs={12} item>
              <Paper className={classes.paper} >
              <p style={{textAlign:'center'}}><NavLink  to="/" style={{textDecoration:'none'}}><span className={classes.closePassWin}>Close</span></NavLink></p>
              </Paper>
        </Grid>       
        </Grid>
      </Grid>
     </Grid>  
    </form>
      </Typography>
    </Container>
    </div>
  </React.Fragment>    
  );
}
//Start PasswordUpdated component code ...